import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconItemDelete from '@/icons/ItemDelete.svg';

export const ArticleRequalificationRefusedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_requalification_refused'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator.name;
  const workshopName = activity.workshop.name;
  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  switch (activity.data.nextStep) {
    case 'new-diagnosis':
      return (
        <BaseActivity
          createdAt={activity.createdAt}
          type="danger"
          icon={<IconItemDelete />}
          message={
            <BaseActivityText>
              <Trans id="activities.article_requalification_refused.message.new-diagnosis">
                <strong>{creatorName}</strong> refused the quote for the item {articleName} and
                chose to start a new diagnosis
              </Trans>
            </BaseActivityText>
          }
        >
          <BaseActivityDetailedContent>{activity.data.comment}</BaseActivityDetailedContent>
        </BaseActivity>
      );

    case 'new-analysis':
      return (
        <BaseActivity
          createdAt={activity.createdAt}
          type="danger"
          icon={<IconItemDelete />}
          message={
            <BaseActivityText>
              <Trans id="activities.article_requalification_refused.message.new-analysis">
                <strong>{creatorName}</strong> refused the quote for the item {articleName} and
                requested a revised quote from {workshopName}
              </Trans>
            </BaseActivityText>
          }
        >
          <BaseActivityDetailedContent>{activity.data.comment}</BaseActivityDetailedContent>
        </BaseActivity>
      );

    case 'return-as-is':
      return (
        <BaseActivity
          createdAt={activity.createdAt}
          type="danger"
          icon={<IconItemDelete />}
          message={
            <BaseActivityText>
              <Trans id="activities.article_requalification_refused.message.return-as-is">
                <strong>{creatorName}</strong> refused the quote for the item {articleName} and
                chose to return the item to the customer as is
              </Trans>
            </BaseActivityText>
          }
        >
          <BaseActivityDetailedContent>{activity.data.comment}</BaseActivityDetailedContent>
        </BaseActivity>
      );

    default:
      return (
        <BaseActivity
          createdAt={activity.createdAt}
          type="danger"
          icon={<IconItemDelete />}
          message={
            <BaseActivityText>
              <Trans id="activities.article_requalification_refused.message">
                <strong>{creatorName}</strong> refused the quote for the item {articleName}
              </Trans>
            </BaseActivityText>
          }
        >
          <BaseActivityDetailedContent>{activity.data.comment}</BaseActivityDetailedContent>
        </BaseActivity>
      );
  }
};
